import React from 'react';
import { FaStar } from 'react-icons/fa';

const testimonials = [
  {
    name: 'Poola Theja',
    institution: 'Dravidian University, MBA',
    stars: 4,
    quote: 'The internship program is conducted well, I done my internship in finance module, it was good. The subject they teach us is very useful and my career development.'
  },
  {
    name: 'Vaishnav Manisha',
    institution: 'Telangana Mahila Viswavidyalayam, Commerce Department',
    stars: 5,
    quote: 'I have learnt many things during this training and also developed many skills. I got the chance to do the projects and also learned about the resume building. Lastly I would like to implement the skills which I have learnt so far.'
  },
  {
    name: 'Anushka Shrivastava',
    institution: 'S K Somaiya College',
    stars: 4,
    quote: 'I highly appreciate internselite for giving me this wonderful opportunity to enhance my knowledge and a huge thanks to the mentors for their utmost support and guidance.'
  },
  {
    name: 'A Sowmya',
    institution: 'University College for Women, Koti, (Commerce)',
    stars: 5,
    quote: 'Finance mentor was the best—her perfect teaching and practical projects transformed me from a beginner to a proficient accountant in just 3 months.'
  },
  {
    name: 'Priya kumari Sahu',
    institution: 'Kiit University, (B.Com)',
    stars: 5,
    quote: 'The Training and Internship provided an amazing hands-on experience, offering valuable knowledge in accounting principles and real-world applications. Exceptional mentor guidance and collaborative project work built a solid foundation, preparing me for future career opportunities.'
  },
  {
    name: 'Ansh Verma',
    institution: 'Gurugram University, (Finance Department)',
    stars: 4,
    quote: 'The faculties are so well known and knowledgeable in their courses, I learn a lot in short time, thanks for the experience.'
  }
];

function FA_Review_Program_Page() {
  return (
    <div>
      <div className='container'>
        <div className='row d-sm-block d-md-none'>
          <div className='col-md-1'></div>
          <div className='col-md-10'>
            <div className='text-center review_component_text'>
              <h2 className='display-5 pb-2'>Testmonial</h2>
              <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
        <div className='row'>
          <div className='col-md-4 pt-5'>
            <div className='Program_review_comp'>
              <div className='mt-5 px-5 review_component_text'>
                <h2 className='pt-5 display-6'>Hear What Our Students Say</h2>
                <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div className='row'>
              {testimonials.map((testimonial, index) => (
                <div key={index} className={`col-md-${index % 2 === 0 ? 5 : 7} card`}>
                  <div className='card-body'>
                    <h5 className='font-weight-bold Review_not_copy'>{testimonial.name}</h5>
                    <h6 className='font-weight-bold my-2 Review_not_copy'>{testimonial.institution}</h6>
                    <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                      {[...Array(5)].map((_, i) => (
                        <li key={i}>
                          <FaStar color={i < testimonial.stars ? "gold" : "gray"} />
                        </li>
                      ))}
                    </ul>
                    <p className='Review_not_copy'>
                      <i className='fas fa-quote-left pe-2'></i>{testimonial.quote}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FA_Review_Program_Page;
